export default __webpack_public_path__ + "static/media/matthew.d90ee78e.jpg";